export default {
  presenter: 'baler',
  title: 'WireGuard',
  subtitle: 'mírně pokročilí',
  text: `
WireGuard je nová a nadějná metoda pro tvorbu VPN. Podíváme se, jak WireGuard použít pro vytvoření
jak základních hvězdicových a mřížkových topologií, tak na jejich kombinace. Na závěr nakousneme,
jak je to s vysokou dostupností (HA), se kterou sice autoři ve svém návrhu nepočítají, ale je
možné ji zařídit.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/baler-wireguard.js